<template>
    <div class="contain">
        <div class="page-header">
            <h1 class="page-title">检测信息</h1>
            <div style="display: flex;align-items: center;">
                <InputField style="width:60%;margin-right: 1rem;" label="" type="text" id="title" :modelValue="form.title"
                            placeholder="请输入标题" labelWidth="0"
                            @update:modelValue="(value) => handleModelValueUpdate('title', value)"
                />
                <a-space>
                    <ButtonField text="查询" @click="query" secondary />
                    <ButtonField text="新增" @click="detection" primary />
                    <ButtonField text="检测" @click="$router.push('expert-appraisal')" secondary />
                </a-space>
            </div>
        </div>
        <div class="content">
          <Tablelist :showCheckbox="false"
                     :list="list"
                     :columns="tableColumns"
                     :totalSize="totalSize"
                     :totalPages="totalPages"
                     :pageNum="pageNum"
                     :pageSize="pageSize"
                     @page-change="onChange"
          >
              <template v-slot:actions="{ item }">
                  <a-space>
                      <a href="#" @click.prevent="editText(item)">编辑</a>
                      <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                  </a-space>
              </template>
          </Tablelist>
        </div>


        <Modal v-if="detectionShow" v-model="detectionShow"
               :visible="detectionShow"
               title="检测信息"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'60%'"
               @update:visible="detectionShow = $event">
           <detectionForm style="height: 70vh" :detectionForm="detectionForm" @cancel="detectionShow = false" @handle-submit="handleSubmit"/>
        </Modal>
    </div>
</template>

<script>
import detectionForm from "./detectionForm.vue";
import { fetchDetectionList,saveDetection,remove,modifyDetection } from "@/views/diagnose/api/diagnose";
export default {
    components:{
        detectionForm
    },
    data() {
        return {
            form:{name:''},
            totalSize: 1,
            totalPages: 1,
            pageNum: 1,
            pageSize: 10,
            list:[],
            tableColumns:[
              {key: 'title',title: '标题',field: 'title',width: '100px'},
              {key: 'detectionDate',title: '检测日期',field: 'detectionDate',width: '100px'},
              {key: 'man',title: '检测人',field: 'man',width: '100px'},
              {key: 'result',title: '检测结果',field: 'result',width: '100px'},
              {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '100px'},
            ],
            detectionShow:false,
            detectionForm:{}
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        query(){
            this.pageNum = 1;
            this.pageSize = 10;
            this.getList();
        },
        onChange(pagination) {
            this.pageNum  = pagination;
            this.pageSize = 10;
            this.getList();
        },
        detection(){
          this.detectionShow = true;
        },
        getList(){
            fetchDetectionList({
                title:this.form.title,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            }).then(res => {
                this.detectionShow = false;
                if (res && res.list && Array.isArray(res.list)) {
                    this.totalSize = res.totalSize;
                    this.totalPages = res.totalPages;
                    res.list.forEach(item => {
                        if (item.detectionDate) {
                            const datePart = item.detectionDate.match(/^\d{4}-\d{2}-\d{2}/);
                            if (datePart) {
                                item.detectionDate = datePart[0];
                            }
                        }
                    });
                }
                this.list = res.list;
            })
        },
        handleSubmit(form){
            console.log("form::::",form)
            if(!form.id){
                saveDetection(form).then((res) => {
                    console.log("res:", res);
                    this.getList();
                }).catch((error) => {
                    console.error("保存失败:", error);
                });
            }else{
                modifyDetection(form).then((res) => {
                    console.log("res:", res);
                    this.getList();
                }).catch((error) => {
                    console.error("保存失败:", error);
                });
            }
        },
        editText(item){
            this.detectionShow = true;
            this.detectionForm = item;
        },
        deleteText(item){
            remove({
                id: item.id,
                type: "diagnose_detection"
            }).then((res) => {
                console.log("res:", res);
                this.getList();
            }).catch((error) => {
                console.error("删除失败:", error);
            });
        }
    }
};
</script>

<style scoped>
.contain{
    width: 80%;
    margin:2rem auto;
}
.content{
    background: rgba(20, 35, 70, 0.5);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
}
.page-header {
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
}

.page-title {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    background: linear-gradient(135deg, #fff, #00ff96);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>